/**
 * Requires specific keys from another type.
 */
export type RequireKeys<T, K extends keyof T> = Exclude<T, K> &
  Required<Pick<T, K>>;
